export default __webpack_public_path__ + "static/media/34.6bfa27ec.svg";